<!--
 * @Descripttion:
 * @version:
 * @Author: guantingting
 * @Date: 2019-07-24 14:13:42
 * @LastEditors: Please set LastEditors
 -->
<template>
  <div class="order-detail">
    <!--
        渐变背景图 （待评价 或 已完成） 且 未申请退款 的，少了一行，
        原order-bg背景高度会减小，融合后不变
        class="order-detail-con"
        :class="{
        'order-bg':
          order.refundState == 10 &&
          (order.orderState === 30 || order.orderState === 40),
      }"
    -->
    <div v-if="order.orderId" class="order-detail-con">
      <!---- 订单状态栏 -->
      <status
        :order="order"
        :groupTime="groupDetail.groupEndTime"
        :synthesisStateDesc="orderSynthesisStateDesc"
      ></status>

      <!---- 商家商品信息 -->
      <product
        :product="product"
        :orderStatus="order.orderState"
        :stateDesc="order.orderStateDesc"
        :order="order"
        :isCustomisedGoods="isCustomisedGoods"
      />

      <!---- 普通自营摄影-预约拍摄到店时间 -->
      <takePhotoReserveDateTime
        :order="order"
        :reserveRecord="order.reserveRecord"
        v-if="hasReserveFloor"
      ></takePhotoReserveDateTime>

      <!---- 云摄影拍摄步骤节点 -->
      <selfPhotoCloudPhotoSteps :order="order" v-if="hasCloudPhotoStageFloor">
      </selfPhotoCloudPhotoSteps>

      <!-- 在线教育 老师二维码 -->
      <teacher-qrcode
        v-if="shouldShowTeacherQrcodeExtension"
        :extTeacherInfo="teacherQrcodeExtension"
      />
      <!-- 三方API订单服务 使用说明-->
      <ThirdPartUseGuide v-if="order.useDesc" :useDesc="order.useDesc || ''" />

      <!--核销区块 统一展开 替换原signatures组件-->
      <!-- 平台码，异业，三方码-->
      <SignaturesMerged
        v-if="hasSignature"
        :codeList="checkBarcodeList"
        :channelType="order.channelType"
        :groupStaus="groupDetail.smallGroupStatus"
        @barCode="barCode"
        :isThirdParty="order.isThirdParty"
      />

      <ThirdPartQrCode
        v-if="
          order.voucherMap &&
          order.voucherMap.voucherInfos &&
          order.voucherMap.voucherInfos.length > 0
        "
        :codeList="order.voucherMap.voucherInfos"
      />
      <ThirdPartExtraInfo
        v-if="
          order.resourceOrderExtendInfos &&
          order.resourceOrderExtendInfos.length > 0
        "
        :custom-info="order.resourceOrderExtendInfos"
      />

      <!-- 教育品类权益卡套餐 -->
      <course-package
        v-if="
          order.skuSecType === 701 &&
          order.coursePackage &&
          order.coursePackage.length > 0
        "
        :list="order.coursePackage"
      />

      <!---- 适用门店 -->
      <suitable-store
        v-if="hasStore"
        :spu-id="order.spuId"
        :businessKey="businessKey"
        :isCustomisedGoods="isCustomisedGoods"
        :isSelfPhoto="order.selfPhotoType && +order.selfPhotoType > 0"
        :isInOrderDetail="true"
        :title-from="'订单详情'"
        class="suitable-store--w"
      ></suitable-store>

      <!-- 套餐项目 -->
      <Combo
        v-if="choosePackageItems.length > 0"
        class="combo-wrap"
        :selectedCombos="choosePackageItems"
        :selectable="false"
      ></Combo>

      <!---- serve 服务信息 服务人员 -->
      <!--skutag5.POP实物和skutag7：pop到家 去除服务人员和服务人员电话-->
      <serve
        :worker="worker"
        :order="order"
        v-if="hasServe && !hideServeCompsYunChanJiaTHG"
      ></serve>

      <!---- 游玩日期 -->
      <travelDate
        :date="order.travelDate"
        :is602="order.skuSecType === 602"
        v-if="hasTravelDate && order.travelDate && order.purchaseType !== 1"
      ></travelDate>

      <!-- 采集信息-自定义名值 可含报名人、联系人、取票人等 -->
      <collectCustomInfo
        :customInfo="order.collectInfo.custom"
        v-if="order.collectInfo && order.collectInfo.custom"
      >
      </collectCustomInfo>

      <!-- 出行人游客信息 -->
      <travelers
        :travelers="order.collectInfo.travelPerson.reqParam"
        v-if="
          order.collectInfo &&
          order.collectInfo.travelPerson &&
          order.collectInfo.travelPerson.reqParam
        "
      >
      </travelers>

      <!--- 订单价格信息 -->
      <priceAndOrderInfoList
        :product="product"
        :orderStatus="order.orderState"
        :synthesisStateDesc="orderSynthesisStateDesc"
        :order="order"
        :state="state"
        :remark="order.remark"
      >
      </priceAndOrderInfoList>

      <!---- users 被当作消费用户及地址信息 -->
      <users :worker="worker" :order="order" v-if="hasAddress"></users>

      <div class="express-info" v-if="order.expressName && order.expressId">
        <div class="express-title pf-medium">快递信息</div>
        <div class="express-detail">
          <div class="item-cell-hd">{{ order.expressName }}</div>
          <div class="item-cell-bd">
            <span id="success_form_input_express">{{ order.expressId }}</span
            ><button
              ref="copy"
              @click="copyExpressId"
              :data-clipboard-text="order.expressId"
              data-clipboard-target="#success_form_input_express"
              class="copyText"
            >
              复制
            </button>
          </div>
        </div>
      </div>

      <!--  赠品 -->
      <reward-gift
        :list="promotionGiveVoList"
        :order="order"
        v-if="promotionGiveVoList.length > 0"
      ></reward-gift>

      <!-- 操作按钮组 -->
      <buttons
        :order="order"
        :groupDetail="groupDetail"
        @cancelOrder="cancelOrder"
        @returnOrder="returnOrder"
        @selfUseCode="selfUseCode"
      >
      </buttons>

      <van-popup
        v-model="showRefundPopup"
        round
        position="bottom"
        closeable
        :style="{ height: '50%' }"
      >
        <div class="third-refund-wrapper">
          <h3>申请退款</h3>
          <p class="trip">
            商家预计1个工作日处理，若同意，款项预计<span>1-7个工作日</span>原路退回
          </p>
          <p class="product-info">
            <span>
              {{ order.businessName }}{{ order.skuName }}x{{ cancelNum }}
            </span>
            <span class="tag" v-if="order.isAnyTimeRefund === 1">随时退</span>
          </p>
          <div class="bottom menu_wkBox_back_box">
            <p @click="refundThirdTravel">申请退款</p>
          </div>
        </div>
      </van-popup>

      <!--- 取消订单 取消原因列表弹窗 -->
      <actionSheet :viewName="viewName" :params="params"></actionSheet>

      <!-- 不要删除 iPhone X 底部高度-->
      <div class="menu_wkBox_back_box"></div>

      <codeModal
        :visiable="selfModalVisiable"
        :title="isPopYuesao ? '提示' : '确认完成'"
      >
        <div class="item-cells dialog-useCode">
          <!-- 联营月嫂确认完成提示 -->
          <p class="summary" v-if="isPopYuesao">
            确认完成后，本平台即会向商家支付全额款项，为了保障您的个人权益，请于月嫂服务结束并下户后，再确认订单完成
          </p>
          <!-- 家电洗护确认完成提示 -->
          <p class="summary" v-if="isApplianceWash">
            确认完成后，本平台即会向商家支付全额款项，为了保障您的个人权益，请于工作人员服务完成后，再确认订单完成
          </p>
          <!-- 其他订单确认完成提示 -->
          <p class="summary" v-else>
            <span class="tip">提示:</span
            >一旦确认完成，即表明您同意本平台向商家支付全额款项，并后续产生的一切纠纷及/或损失均由您自行承担，与本平台无关。
          </p>

          <div class="button">
            <div class="selfcancel" @click="selfModalCanlcel">取消</div>
            <div class="selfok" @click="postCode()">确认完成</div>
          </div>
        </div>
      </codeModal>

      <div id="confirm_delete_order_dialog">
        <div class="item-cells dialog-useCode">
          <p class="summary">确认删除该订单吗？</p>
        </div>
      </div>
    </div>
    <empty v-else v-show="!firstFetch" :text="errText"></empty>
    <loading :visible="orderLoadingVisible"></loading>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import status from '@/components/newOrder/order-status'
import coursePackage from '@/components/newOrder/course-package'
import takePhotoReserveDateTime from '@/components/newOrder/takePhotoReserveDateTime'
import selfPhotoCloudPhotoSteps from '@/components/newOrder/selfPhotoCloudPhotoSteps'
import signatures from '@/components/newOrder/signature'
import TeacherQrcode from '@/components/newOrder/TeacherQrcode.vue'
import ThirdPartUseGuide from '@/components/newOrder/ThirdPartUseGuide.vue'
import SignaturesMerged from '@/components/newOrder/signatureMerged'
import ThirdPartQrCode from '@/components/newOrder/ThirdPartQrCode.vue'
import ThirdPartExtraInfo from '@/components/newOrder/ThirdPartExtraInfo.vue'
import product from '@/components/newOrder/product'
import serve from '@/components/newOrder/serve'
import Combo from '@/components/confirm/combo'

// import price from '@/components/newOrder/price'
// import infoList from '@/components/newOrder/infoList'
// 合并
import priceAndOrderInfoList from '@/components/newOrder/priceAndOrderInfoList'

import users from '@/components/newOrder/user'
import travelDate from '@/components/newOrder/travelDate'
import collectCustomInfo from '@/components/newOrder/collectCustomInfo'
import travelers from '@/components/newOrder/travelers'

import { setOrderId } from '@/business/order/confirmParams'

import buttons from '../components/buttons'

import actionSheet from '@/components/actionSheet'
import empty from '@/components/common/empty'
import { Msgbox } from 'kf-component-vue'
import loading from '@/components/common/loading/custome-loading'
import { pushHref, pushNrNs } from '@/plugins/jump'
import {
  isNewAsignedMonthInLaw,
  B_ORDER_Detail,
  getOrderSynthesisStateDesc
} from '@/business/order'
import SuitableStore from '@/components/storeInfo/suitableStore/withoutImage'
import { isNonEmptyArray, isTrue } from '@/utils'
import RewardGift from '../components/gift'
import mixProm from '@/mixin/mixProm'
import { E_PROMOTION_TYPE } from '@/config'
import {
  E_ORDER_TYPE,
  ORDER_MONEY_PAY_TYPE,
  E_SKUTAG,
  ORDER_STATE_ENUM,
  ORDER_BELONG_BUSI_ENUM,
  ORDER_REFUND_STATE_ENUM,
  SELF_PHOTO_TYPE_ENUM,
  SELF_PHOTO_NORMAL_SUPORRT_RESERVE_ENUM,
  CLOUD_PHOTO_STATE_ENUM,
  ORDER_TYPE_FOR_PERIOD
} from '@/config'
import codeModal from '@/components/newOrder/codeModal'
import { Indicator } from 'mint-ui'
import { pageReloadInStatusChange } from '@/utils/order/orderEvent'
import { Popup, Toast } from 'vant'
// 码状态barcodeState 0:待使用，1 已核销，3过期
export default {
  mixins: [mixProm],
  inject: {
    reload: {},
    detailTrackParams: {
      default: null
    }
  },
  data() {
    return {
      firstFetch: true,
      orderCode: '',
      errText: '订单不存在',
      price: 0,
      params: {},
      groupDetail: {},
      orderLoadingVisible: false,
      ORDER_MONEY_PAY_TYPE,
      selfModalVisiable: false,
      showRefundPopup: false,
      cancelNum: ''
    }
  },
  async created() {
    this.$$title('订单详情')
    pageReloadInStatusChange()
    try {
      this.orderCode = this.$route.params.orderCode
      const { uid, skey } = await this.$$ensureLogin()
      const res = await this.$store.dispatch('getOrderDetail', {
        uid,
        skey,
        orderCode: this.orderCode
      })
      if (res.code * 1 === 4) {
        this.$$login()
        return
      }
      if (isNewAsignedMonthInLaw(this.order)) {
        // location.replace(location.href + `&isys=1`)
        this.$router.replace(this.$route.fullPath + `&isys=1`)
        this.reload()
        return
      }
      const { channelType, groupId } = this.order
      channelType === 4 && groupId && this.getGroupDetail(uid, groupId)
      this.firstFetch = false
      if (this.order.coupon_code && this.order.coupon_code !== '') {
        this.$store.commit('setSelectedCoupon', {
          Code: this.order.coupon_code,
          Price: this.order.coupon_amt,
          Name: this.order.coupon_name
        })
      }

      this.$$loading(false)
      this.$store.dispatch('getReasons')
      this.$nextTick(() => {
        if (this.$refs.copy)
          this.copyBtn = new this.$$clipboard(this.$refs.copy)
      })
      // this.address();
    } catch (e) {
      this.firstFetch = false
      this.$$loading(false)
      if (e.message === '4') {
        this.$$login()
      } else {
        this.errText = '查询订单异常'
      }
    }
    this.detailTrackParams &&
      this.$$newTrackView({
        ...this.detailTrackParams,
        pageParam: {
          skutype: this.order.skuSecType
        }
      })
  },
  mounted() {
    this.$$allowRefreshOrShare(true, false)
  },
  computed: {
    ...mapState(['viewName', 'order', 'refundReasons']),
    skuTag() {
      const { skuTag } = this.order
      return skuTag
    },
    orderSynthesisStateDesc() {
      return getOrderSynthesisStateDesc(this.order)
    },
    hasReserveFloor() {
      // 是否自营摄影 非二销扫码付,支持预约
      const {
        selfPhotoType,
        supportReserve,
        orderState,
        channelType,
        reserveRecord
      } = this.order
      //E_PROMOTION_TYPE.SCAN_BUY_PHOTO != channelType 等价于 SELF_PHOTO_TYPE_ENUM.SCAN_BUY == selfPhotoType
      return (
        SELF_PHOTO_TYPE_ENUM.NORMAL == selfPhotoType &&
        SELF_PHOTO_NORMAL_SUPORRT_RESERVE_ENUM.YES == supportReserve &&
        ORDER_STATE_ENUM.TO_BE_USED == orderState &&
        reserveRecord
      )
    },
    hasCloudPhotoStageFloor() {
      // 是否云摄影 非加修补充单 (非 待支付  或  非 未支付已取消)
      const { orderState, refundState, selfPhotoType, payPeriodType } =
        this.order
      return (
        SELF_PHOTO_TYPE_ENUM.CLOUD == selfPhotoType &&
        ORDER_TYPE_FOR_PERIOD.CLOUD_PHOTO_APPEND_CHILD_ORDER != payPeriodType &&
        !(
          ORDER_STATE_ENUM.PENDING_PAY == orderState ||
          ORDER_STATE_ENUM.CANCELED == orderState
        )
      )
    },
    hasSignature() {
      //"showBarcode": 1,  // 三方API控制是否展示核销码 0 不展示 1 展示
      // 是否不是联营月嫂和pop实物
      const { skuTag, showBarcode } = this.order
      return (
        skuTag != E_SKUTAG.POPYUSAO &&
        skuTag != E_SKUTAG.POPENTITY &&
        skuTag != E_SKUTAG.UNIONHOME &&
        skuTag != E_SKUTAG.APPLIANCE_WASHING &&
        showBarcode === 1
      )
    },
    hasTravelDate() {
      // 是否旅游门票601
      const { skuSecType } = this.order
      return (
        E_SKUTAG.TRAVEL_TICKET == this.skuTag &&
        (601 == skuSecType || 602 == skuSecType)
      )
    },
    hasServe() {
      return B_ORDER_Detail.showServeInfo(this.skuTag)
    },
    // 2023-08-02 孕产加特惠馆项目
    // 孕产特惠馆自营商家产品不需要服务人员、服务门店、服务时间
    // isNeedServiceMan: 1 需要 / 0 不需要
    hideServeCompsYunChanJiaTHG() {
      const { isNeedServiceMan } = this.order
      return (
        [E_SKUTAG.SELFSTORE, E_SKUTAG.SELFHOME].includes(this.skuTag) &&
        isNeedServiceMan === 0
      )
    },
    hasStore() {
      // 扫码付不展示门店
      const { channelType, skuSecType } = this.order
      //课程套餐商品701订单一律隐藏适用门店
      if (skuSecType == 701) return false
      if (channelType === E_ORDER_TYPE.SCAN_BUY) return false
      // 定制sku商品默认展示门店
      const bool = this.isCustomisedGoods
      if (bool) return true
      return B_ORDER_Detail.showStoreInfo(this.skuTag)
    },
    hasAddress() {
      const address =
        this.order.collectInfo &&
        this.order.collectInfo.deliveryAddr &&
        this.order.collectInfo.deliveryAddr.reqParam
          ? this.order.collectInfo.deliveryAddr.reqParam
          : ''

      return address && B_ORDER_Detail.showAddressInfo(this.skuTag)
    },
    isUseCustomSignature() {
      return B_ORDER_Detail.isUseCustomSignature(this.skuTag)
    },

    isCustomisedGoods() {
      // 是否为定制sku商品
      let bool = false

      if (
        this.order.extInfo &&
        this.order.extInfo.find(
          x => x.labelKey === 'customisedGoods' && isTrue(x.labelValue)
        )
      ) {
        bool = true
      }
      return bool
    },
    shouldShowTeacherQrcodeExtension() {
      // "showExtension": 1, // 是否展示回传信息 0 不展示 1 展示
      let bool = false
      if (
        this.order.showExtension === 1 &&
        this.order.extInfo &&
        this.order.extInfo.find(x => x.labelKey === 'wxAccount' && x.labelValue)
      ) {
        bool = true
      }
      return bool
    },
    teacherQrcodeExtension() {
      if (!this.shouldShowTeacherQrcodeExtension) {
        return ''
      }
      let description = ''
      let wxAccount = ''
      let qrCode = ''
      if (this.order.extInfo) {
        let obj = this.order.extInfo.find(x => x.labelKey === 'description')
        description = obj && obj.labelValue
        obj = this.order.extInfo.find(x => x.labelKey === 'wxAccount')
        wxAccount = obj && obj.labelValue
        obj = this.order.extInfo.find(x => x.labelKey === 'qrCode')
        qrCode = obj && obj.labelValue
      }
      return {
        description,
        wxAccount,
        qrCode
      }
    },
    promotionGiveVoList() {
      if (this.order) {
        const { promotionGiveVoList, orderState, channelType } = this.order
        // 订单详情商品本身就是赠品，则不会再附送赠品
        if (+channelType === E_ORDER_TYPE.REWARD_GIFT) return []
        if (
          ORDER_STATE_ENUM.PENDING_PAY == orderState ||
          ORDER_STATE_ENUM.TO_BE_USED == orderState ||
          ORDER_STATE_ENUM.WAITING_4_EVALUATE == orderState ||
          ORDER_STATE_ENUM.FINISHED == orderState
        ) {
          if (isNonEmptyArray(promotionGiveVoList)) {
            return promotionGiveVoList
          }
        }
      }
      return []
    },
    product() {
      return {
        endPayPrice: this.order.payPeriodInfo
          ? this.order.payPeriodInfo.endPayOrder.endPayPrice
          : 0,
        wholeDiscount:
          this.order.reduceInfo && this.order.reduceInfo.reducePrice
            ? this.order.reduceInfo.reducePrice + this.order.discountAmt
            : this.order.discountAmt,
        preOrderPrice: this.order.payPeriodInfo
          ? this.order.payPeriodInfo.prePayOrder.preOrderPrice
          : 0,
        endOrderPrice: this.order.payPeriodInfo
          ? this.order.payPeriodInfo.endPayOrder.endOrderPrice
          : 0,
        Pic: this.order.commdtyImage,
        businessName: this.order.businessName,
        Title: this.order.spuName,
        Sku: this.order.skuName,
        Id: this.order.spuId,
        refund_supply: this.order.allow_return,
        Price: this.order.orderPrice,
        TotalPrice: this.order.orderPrice,
        ActualPrice: this.order.payPrice,
        num: this.order.num,
        refund_anytime: this.order.isAnyTimeRefund,
        refund_overdue: this.order.isExpireRefund,
        trade_type: this.order.vorder_type,
        isPosPay: this.order.isPosPay,
        userType: this.order.userType,
        serviceCode: this.order.serviceCode,
        spuId: this.order.spuId,
        discountAmt: this.order.discountAmt,
        reduceInfo: this.order.reduceInfo
      }
    },
    worker() {
      const address =
        this.order.collectInfo &&
        this.order.collectInfo.deliveryAddr &&
        this.order.collectInfo.deliveryAddr.reqParam
          ? this.order.collectInfo.deliveryAddr.reqParam
          : {}
      const serviceTime =
        this.order.extInfo &&
        this.order.extInfo.find(item => item.labelKey == 'serviceTime')
      const ext = serviceTime ? serviceTime.labelValue : ''
      return {
        headImage: this.order.headImage,
        userType: this.order.userType,
        address: address.address || '',
        workerCode: this.order.home_worker,
        workerName: this.order.workerName,
        mobile:
          this.order.level4CategoryId === '10111019'
            ? ''
            : this.order.workerMobile,
        uid: this.order.workerUid,
        storeName: this.order.workerStoreName,
        userName: address.name || '',
        contact: address.mobile || '',
        dateTime: ext,
        regionIds: address.regionid || '',
        servicedTimes: this.order.servicedTimes,
        serviceCode: this.order.serviceCode,
        spuId: this.order.spuId
      }
    },
    state() {
      return this.order.orderState // 10.待支付20.待使用30.待评价40.已完成50.已取消(可选项)
    },
    canRefund() {
      // 所有码都未使用才可以申请退单，0元订单不支持申请退单  商品必须是随时退才露出申请退款
      const codes = this.order.barcodeList || []
      let canUseCodes = codes
      if (codes && codes.length > 0) {
        canUseCodes = codes.filter(v => v.barcodeState === 0)
      }
      const product_state = this.order.isAnyTimeRefund === 1 // 随时退
      return (
        (this.order.refundState === 10 || this.order.refundState === 40) &&
        product_state &&
        canUseCodes.length === codes.length &&
        this.order.payPrice !== 0
      ) // 0元不退
    },
    businessKey() {
      // pop门店ID
      let obj =
        this.order.extInfo &&
        this.order.extInfo.find(x => x.labelKey === 'popStoreCode')
      if (obj) {
        return obj.labelValue
      }
      return null
    },
    // 套餐项目
    choosePackageItems() {
      const obj =
        this.order.extInfo &&
        this.order.extInfo.find(item => item.labelKey == 'choosePackageItems')
      if (obj && obj.labelValue) {
        return JSON.parse(obj.labelValue)
      }
      return []
    },
    // 未核销
    newCodes() {
      let codeList = this.order.barcodeList || []
      const news = codeList.filter(ele => ele.barcodeState === 0)
      return news
    },
    checkBarcodeList() {
      return this.order.barcodeList
    },
    isPopYuesao() {
      return this.skuTag == E_SKUTAG.POPYUSAO
    },
    isApplianceWash() {
      return this.skuTag == E_SKUTAG.APPLIANCE_WASHING
    }
  },
  methods: {
    ...mapMutations(['showActionSheet', 'setActionHeader', 'changeView']),
    barCode(v) {
      this.orderLoadingVisible = v
    },
    copyExpressId() {
      let _this = this
      let clipboard = _this.copyBtn
      clipboard.on('success', function (e) {
        _this.$$toast('复制成功')
        return
      })
      clipboard.on('error', function (e) {
        window.prompt('复制失败，请手动复制', e.text)
      })
    },
    // 未核销
    mNewCodes() {
      let codeList = this.order.barcodeList || []
      const news = codeList.filter(ele => ele.barcodeState === 0)
      return news
    },
    cancelOrder() {
      this.changeView('cancelReason')
      this.setActionHeader({
        title: '取消原因'
      })
      this.showActionSheet()
    },
    async selfUseCode() {
      //自助核销
      this.selfModalVisiable = true
    },
    async postCode() {
      this.selfModalVisiable = false
      this.$emit('barCode', true)
      const serveCode = this.order.workerUid
      const uid = this.$$cookie('uid')
      const skey = this.$$cookie('skey')

      const order = this.order
      let orderId = order.orderId
      if (order.isPayPeriod && order.isPayPeriod == 1 && order.payPeriodInfo) {
        //定金尾款
        const { endPayOrder = {} } = order.payPeriodInfo
        if (
          endPayOrder.endOrderState &&
          endPayOrder.endOrderState == ORDER_STATE_ENUM.TO_BE_USED
        ) {
          //尾款单号核销
          orderId = endPayOrder.endOrderId
        }
      }

      const param = {
        uid,
        skey,
        vorderId: orderId
        // barcode: itemCode,
      }
      Indicator.open()
      const code_res = await this.$store.dispatch('useCode', param)
      this.$emit('barCode', false)
      if (code_res.code === '1') {
        this.$$toast('核销成功')
        if (this.mNewCodes.length === 0) {
          // 码全部核销完毕
          // 重新调用详情接口
          const res = await this.$store.dispatch('getOrderDetail', {
            uid: this.$$cookie('uid'),
            skey: this.$$cookie('skey'),
            orderCode: this.order.orderId
          })
          if (res) {
            // this.$emit('barCode', false)
            setTimeout(() => {
              if (ORDER_BELONG_BUSI_ENUM.CZJ == this.order.businessType) {
                //21育儿 20 成长加
                let url = `//m.czj100.com/comment/publish2product?id=${this.order.spuId}&orderId=${this.order.orderId}&cmd=share&sharetype=0&refresh=no`
                //TODO 登录态问题待处理
                if (this.$$isHZWApp() || this.$$isCZJApp()) {
                  url = `//app.czj100.com/webridge.html?url=${encodeURIComponent(
                    url
                  )}&uid=${this.$$cookie('uid')}&skey=${this.$$cookie('skey')}`
                }

                location.href = url
              } else {
                pushNrNs({
                  // 新写评价入口
                  name: 'evaluate',
                  query: {
                    orderCode: this.order.orderId,
                    ht: 'add'
                  }
                })
              }
            }, 1000)
          }
        } else {
          this.reload()
        }
      } else if (code_res.code === '4') {
        this.$$login()
      } else {
        this.$$toast(code_res.msg)
      }
      Indicator.close()
    },
    selfModalCanlcel() {
      this.selfModalVisiable = false
    },
    async refundThirdTravel() {
      Toast.loading({
        duration: 0,
        message: '申请退款中...',
        forbidClick: false
      })
      const res = await this.$store.dispatch('returnOrder', {
        uid: this.$$cookie('uid'),
        skey: this.$$cookie('skey'),
        vorder_id: this.order.orderId,
        refund_reason: this.refundReasons && this.refundReasons[0]
      })
      Toast.clear()
      if (res.code * 1 === 1) {
        this.order.refundState = 20
        this.showRefundPopup = false
        this.$$toast('您的退款申请已提交，请等待审核')
      } else if (res.code * 1 === 4) {
        this.$$login()
      } else {
        this.$$toast(res.msg)
      }
    },
    async returnOrder() {
      const { skuSecType } = this.order
      if (skuSecType === 602) {
        Toast.loading({
          duration: 0,
          forbidClick: false
        })
        const res = await this.$store.dispatch('queryCanRefundTicket', {
          uid: this.$$cookie('uid'),
          skey: this.$$cookie('skey'),
          orderId: this.order.orderId
        })
        Toast.clear()
        if (
          res &&
          res.data &&
          res.data.CancelItems &&
          res.data.CancelItems.length > 0
        ) {
          const cancelItem = res.data.CancelItems[0]
          if (cancelItem.CancelItemStatus === 1) {
            this.showRefundPopup = true
            this.cancelNum = cancelItem.RefundQuantity
          } else {
            this.$$toast('订单不可退')
            this.cancelNum = ''
          }
        } else {
          this.$$toast('订单不可退')
          this.cancelNum = ''
        }
        return
      }
      this.changeView('refundReason')
      this.setActionHeader({
        title: '退单原因'
      })
      this.params = {
        payType: this.order.payType,
        partnerType: this.order.partnerType
      }
      this.showActionSheet()
    },
    kefu() {
      if (this.state === 1) {
        // 待支付
        this.$$kefu('XN0202', 'XN0102')
      } else if (this.state === 5) {
        // 取消订单
        this.$$kefu('XN0204', 'XN0104')
      } else if (this.state > 5) {
        // 退款
        this.$$kefu('XN0205', 'XN0105')
      } else {
        this.$$kefu('XN0203', 'XN0103')
        if (this.state === 2) {
        } else if (this.state === 3) {
        }
      }
    },
    async getGroupDetail(uid, groupId) {
      const res = await this.$store.dispatch('getGroupDetail', {
        uid,
        groupId
      })
      if (
        res.code === '1' &&
        res.data &&
        res.data.detailVo &&
        Object.keys(res.data.detailVo).length
      ) {
        this.groupDetail = res.data.detailVo
      }
    }
  },
  components: {
    product,
    coursePackage,
    takePhotoReserveDateTime,
    selfPhotoCloudPhotoSteps,
    serve,
    // infoList,
    // price,
    priceAndOrderInfoList,
    TeacherQrcode,
    ThirdPartUseGuide,
    signatures,
    SignaturesMerged,
    ThirdPartQrCode,
    ThirdPartExtraInfo,
    users,
    SuitableStore,
    Combo,
    RewardGift,
    travelDate,
    collectCustomInfo,
    travelers,
    status,
    actionSheet,
    empty,
    Msgbox,
    loading,
    codeModal,
    buttons,
    [Popup.name]: Popup
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/css/mixin';
/deep/.van-popup__close-icon {
  color: #666;
  font-size: rem(40px);
}
.order-detail {
  min-height: 100%;
  padding-bottom: rem(119px);
  .order-detail-con {
    .suitable-store--w {
    }
    .combo-wrap {
    }
    .express-info {
      .express-title {
      }
      .pf-medium {
      }
      .express-detail {
        .item-cell-hd {
        }
        .item-cell-bd {
          #success_form_input_express {
          }
          .copyText {
          }
        }
      }
    }
    .third-refund-wrapper {
      h3 {
      }
      .trip {
        span {
        }
      }
      .product-info {
        span {
        }
        .tag {
        }
      }
      .bottom {
        p {
        }
      }
      .menu_wkBox_back_box {
      }
    }
    .menu_wkBox_back_box {
    }
    .item-cells {
      .summary {
      }
      .summary {
        .tip {
        }
      }
      .summary {
        .tip {
        }
      }
      .button {
        .selfcancel {
        }
        .selfok {
        }
      }
    }
    .dialog-useCode {
    }
    #confirm_delete_order_dialog {
      .item-cells {
        .summary {
        }
      }
      .dialog-useCode {
      }
    }
  }
}
.third-refund-wrapper {
  position: relative;
  padding: 0 rem(24px);
  h3 {
    color: #121212ff;
    font-weight: 500;
    font-size: rem(32px);
    text-align: center;
    margin-top: rem(36px);
  }
  .trip {
    margin-top: rem(40px);
    border-radius: rem(16px);
    background: #fff9e4ff;
    padding: rem(12px) rem(20px);
    color: #333333ff;
    font-size: rem(24px);
    span {
      color: #ff8850ff;
    }
  }
  .product-info {
    margin-top: rem(20px);
    mix-blend-mode: normal;
    border-radius: rem(16px);
    border: rem(1px) solid #eeeeeeff;
    box-sizing: border-box;
    background: #ffffffff;
    padding: rem(32px) rem(30px);
    box-shadow: 0px 0px rem(20px) #0000001a;
    display: flex;
    flex-direction: column;
    span {
      color: #121212ff;
      font-weight: 500;
      font-size: rem(32px);
    }
    .tag {
      color: #666;
      margin-top: rem(16px);
      font-size: rem(24px);
      display: flex;
      align-items: center;
    }
  }
  .bottom {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    box-shadow: 0px rem(-2px) rem(10px) #0000000f;
    background: #ffffffff;
    p {
      height: rem(80px);
      margin: rem(10px) rem(24px);
      border-radius: rem(40px);
      background: linear-gradient(90deg, #ff8800ff 0%, #ff5900ff 100%);
      text-align: center;
      line-height: rem(80px);
      color: #ffffffff;
      font-weight: 500;
      font-size: rem(30px);
    }
  }
}

.express-info {
  margin: rem(20px) rem(24px) rem(20px);
  padding: rem(32px) rem(24px) rem(30px) rem(24px);
  border-radius: rem(16px);
  background: #fff;
  font-size: rem(24px);
  color: #262626;
  line-height: rem(30px);
  margin-bottom: rem(20px);

  .express-title {
    font-size: rem(30px);
    padding: 0 0 rem(30px) 0;
  }

  .express-detail {
    display: flex;
    .item-cell-hd {
      font-size: rem(26px);
      color: #262626;
      line-height: rem(32px);
    }
    .item-cell-bd {
      font-weight: 500;
      font-size: rem(26px);
      color: #121212;
      line-height: rem(32px);
      text-align: right;
      flex: 1;
    }
    .copyText {
      font-size: rem(26px);
      color: #ff5900;
      line-height: rem(32px);
      margin-left: rem(19px);
    }
  }
}

.order-detail-con {
  background-image: linear-gradient(122deg, #ff5900 0%, #ff8800 100%);
  background-repeat: no-repeat;
  //   background: url('../../assets/images/order/order-bg.png') no-repeat;
  //   border-radius: 0 0 16px 16px;
  background-size: 100% rem(268px);
}

// .order-bg {
// //   background-size: 100% rem(224px);//0729订单融合不再变高度
// }

#confirm_delete_order_dialog {
  display: none;
}
.suitable-store--w {
  margin: 0.2rem 0.24rem;
}

.combo-wrap {
  margin: 0 rem(24px) rem(20px);
}

.dialog-useCode {
  line-height: 1.5;

  .summary {
    text-align: left;
    font-size: rem(28px);
    color: #666666;
    padding: rem(20px) rem(30px) rem(34px);
  }
  .tip {
    display: inline-block;
    color: #000;
    line-height: rem(40px);
    height: rem(34px);
    font-size: rem(28px);
    font-weight: bold;
    text-align: center;
    margin-right: rem(12px);
    // padding: 0 rem(8px);
  }
  .item-cell {
    margin: rem(25px) 0;
  }
  .item-cell-bd {
    white-space: nowrap;
  }
  input {
    margin-left: rem(20px);
    border-bottom: 1px solid #eee;
  }

  .button {
    display: flex;
    align-items: center;
    // justify-content: center;
    @include border(top, #dcdcdc);
    height: rem(88px);

    & > div {
      flex: 1;
      text-align: center;
      background: #ffffff;
      font-size: rem(32px);
      color: #121212;
      line-height: rem(88px);
    }

    .selfok {
      @include border(left, #dcdcdc);
      color: #ff5900;
    }
  }
}
</style>
